import React, { Component } from 'react';

import './style.css';

class PurchaseTotal extends Component {
  render() {
    const { promo, originalCents } = this.props;
    const totalCents = promo ? originalCents - promo.amount_off : originalCents;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    const total = formatter.format(totalCents / 100);
    if (promo && promo.amount_off > 0) {
      const regular = formatter.format(originalCents / 100);
      const discount = formatter.format(promo.amount_off / 100);

      return (
        <div className="discountedPricing">
          <div className="regular">Regular: {regular}</div>
          <div>
            <span className="discount">Discount: -{discount}</span>
          </div>
          <div className="total">
            Total: {total}
            {totalCents === 0 && <span className="free">FREE</span>}
          </div>
        </div>
      );
    }
    return <p>Total: {total}</p>;
  }
}

export default PurchaseTotal;



// WEBPACK FOOTER //
// ./src/components/PurchaseTotal/index.js